import { motion } from "framer-motion";
import ChapterMarker from "../ChapterMarker";
import { EXPERIENCE, SECTIONS } from "../../data/content";

export default function Experience() {
  const s = SECTIONS[2];
  return (
    <section
      id={s.id}
      style={{ minHeight: `${s.weight * 100}vh` }}
      className="relative flex flex-col justify-center gap-16 px-6 md:px-12 lg:px-24 py-24"
      data-testid="section-experience"
    >
      <ChapterMarker number={s.number} label={s.label} />
      <div className="flex flex-col gap-10 md:gap-16">
        {EXPERIENCE.map((exp, i) => (
          <motion.div
            key={exp.id}
            initial={{ opacity: 0, x: i % 2 === 0 ? -30 : 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-15%" }}
            transition={{ duration: 0.65, ease: "easeOut" }}
            className={`pointer-events-auto max-w-xl border border-[#FF007F]/20 bg-[#0A0A12]/60 backdrop-blur-xl p-8 md:p-10 ${
              i % 2 === 0 ? "self-start" : "self-end"
            }`}
            data-testid={`experience-card-${exp.id}`}
          >
            <div className="flex items-baseline justify-between gap-4">
              <span className="font-mono text-[10px] tracking-[0.3em] text-[#FF007F]">
                FLOOR {exp.floor}
              </span>
              <span className="font-mono text-[11px] text-[#8A9AAB]">{exp.period}</span>
            </div>
            <h3 className="mt-3 font-heading text-xl md:text-2xl uppercase text-[#E0E6ED]">
              {exp.role}
            </h3>
            <p className="mt-1 font-mono text-sm text-[#01FFFF]">
              {exp.shortName} — {exp.company}
            </p>
            <ul className="mt-5 space-y-2">
              {exp.bullets.map((b, bi) => (
                <li key={bi} className="font-mono text-xs leading-relaxed text-[#8A9AAB]">
                  — {b}
                </li>
              ))}
            </ul>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
